import React, { useEffect, useState } from "react";

import {
    Spin
} from "antd";
import { TabPanel, TabView } from "primereact/tabview";
import AdjustmentRateConfig from "./AdjustmentRateConfig";
import CompanyConfig from "./CompanyConfig";
import CustomValue from "./CustomValue";
import InvoiceConfig from "./InvoiceConfig";
import ProjectCapacity from "./ProjectCapacity";
import QualityCheckerAutoAssign from "./QualityCheckerAutoAssign";
import ReportOrderComponent from "./ReportOrder";
import UserInvoiceConfig from "./UserInvoiceConfig";
import ContractorInvoiceConfig from "./ContractorInvoiceConfig.jsx";

const Admin = () => {
    const [apiLoading, setApiLoading] = useState(false);

    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        identifyTabs();
    }, [])

    const identifyTabs = () => {
        const newTabsArray = [];
        newTabsArray.push({
            title: "Global Config",
            content: (
                <CustomValue
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "Assigning Page",
            content: (
                <ProjectCapacity
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "AutoAssign QCer Page",
            content: (
                <QualityCheckerAutoAssign
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "Company Config",
            content: (
                <CompanyConfig
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });
        newTabsArray.push({
            title: "Project Invoice Config",
            content: (
                <InvoiceConfig
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "Contractor Invoice Config",
            content: (
                <ContractorInvoiceConfig
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "Fcer/ Qcer Invoice Config",
            content: (
                <UserInvoiceConfig
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });

        newTabsArray.push({
            title: "Rework Config",
            content: (
                <AdjustmentRateConfig
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });
        newTabsArray.push({
            title: "Order Of Report Config",
            content: (
                <ReportOrderComponent
                    loading={apiLoading}
                    setLoading={(e) => {
                        setApiLoading(e);
                    }}
                />
            ),
        });
        setTabs(newTabsArray);
    };


    return (
        <div>
            <Spin spinning={apiLoading}>
                <TabView>
                    {tabs.map((tab) => {
                        return (
                            <TabPanel key={tab.title} header={tab.title}>
                                {tab.content}
                            </TabPanel>
                        );
                    })}
                </TabView>
            </Spin>
        </div>
    );
};

export default Admin;
